import styled from 'styled-components'

export const FooterBarContainer = styled.div`
  width: -webkit-fill-available;
  height: 90px;
  display: flex;
  align-items: center;
  background-color: #0093b2;
  position: fixed;
  bottom: 0;
  z-index: 9;
`

export const FooterBarElement = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const Left = styled.div``

export const SafeAnimals = styled.div`
  display: flex;
  flex-direction: column;
`

export const NrOfSafeAnimals = styled.div`
  font-family: Ubuntu, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.02em;
  text-align: left;
  color: #ffffff;
`

export const ReportContainer = styled.button`
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const ReportIcon = styled.img``

export const ReportText = styled.div`
  font-family: Ubuntu, sans-serif;
  font-size: 12px;
  font-weight: 300;
  line-height: 15px;
  letter-spacing: 0.15em;
  text-align: left;
  color: #ffffff;
  text-decoration: underline;
`

export const Right = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`

export const PaymentContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`

export const InfoIconContainer = styled.div`
  position: relative;
  font-family: Ubuntu;
  color: rgb(102, 102, 102);
`
export const InfoIcon = styled.img``

export const PaymentValue = styled.div`
  font-family: Ubuntu, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.02em;
  text-align: left;
  color: #ffffff;
`

export const AdvanceButtonContainer = styled.div``

export const QuotationButton = styled.div`
  button {
    margin: 0;
  }
`

export const AdvanceButton = styled.button`
  width: 136px;
  height: 44px;
  font-family: Ubuntu, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 2px;
  text-align: center;
  color: #0093b2;
  border-radius: 0;
  cursor: pointer;
  border: 0;
  background-color: #ffffff;

  &:disabled {
    opacity: 0.7;
    pointer-events: none;
  }
`

export const QuotationButtonContainer = styled(AdvanceButton)`
  width: auto;
  padding-left: 16px;
  padding-right: 16px;
  text-transform: uppercase;
`
